import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
